/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import './app.css';
import { connect } from 'react-redux'

import SidebarMenu from './SidebarMenu';

class NavbarRight extends React.Component {
    render() {
        return (
            <div className="navbar-custom-menu">
                <ul className="nav navbar-nav">
                    <li className="dropdown user user-menu">
                        <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                            <span className="hidden-xs">{this.props.name}</span>
                        </a>
                        <ul className="dropdown-menu">
                            <li className="user-header">
                                <img src={require("./avatar.svg")} className="img-circle" alt="User" />
                                <p>
                                    {this.props.name}
                                    <small>.</small>
                                </p>
                            </li>
                            <li className="user-footer">
                                {/*               <div className="pull-left">
                                    <a href="#" className="btn btn-default btn-flat">Profile</a>
        </div>*/}
                                <div className="pull-right">
                                    <button href="#" className="btn btn-default btn-flat" onClick={() => {
                                        localStorage.removeItem("token");
                                        this.props.setToken("")
                                    }}>Salir</button>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        )
    }
};

const Logo = () => {
    return (
        <Link to="/" className="logo">
            <span className="logo-mini"><b>L</b>TT</span>
            <span className="logo-lg"><b>L</b>TT</span>
        </Link>)
}

const Header = (props) => {
    return (
        <header className="main-header">
            <Logo />
            <nav className="navbar navbar-static-top">
                <a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button">
                    <span className="sr-only">Toggle navigation</span>
                </a>
                <NavbarRight setToken={props.setToken} name={props.name} />
            </nav>
        </header>
    );
};

const Footer = () => {
    return (
        <footer className="main-footer">
            <div className="pull-right hidden-xs">
                <b>Version</b> 1.0.0
            </div>
            <strong>
                Copyright © 2021
            </strong>
            Todos los derechos reservados
        </footer>
    )
};

class AppLayout extends React.Component {
    componentDidMount() {

    }
    render() {
        const { title, usuario } = this.props;
        return (
            <div className="wrapper style-wrapper">
                {(!usuario || !Object.keys(usuario).length > 0) && (
                    <Redirect to="/login" />
                )}

                <Header setToken={this.props.setToken} name={this.props.name} />
                <SidebarMenu />

                <div className="content-wrapper style-content-wrapper">
                    <section className="content-header">
                        <h1>{title}</h1>
                    </section>
                    <section className="content">
                        <div className="row">
                            <div className="col-md-12">
                                {this.props.children}
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        usuario: state.usuario
    };
}

export default connect(mapStateToProps)(AppLayout)